import styled from 'styled-components'

export const Container = styled.div`
  width: 24px;
  margin: auto;
  display: block;
  position: relative;

  .checkbox {
    &.checked {
      :after {
        transform: scale(0.5);
        transform-origin: center center;
        transition: all 0.1s ease-in-out 0s;
      }
    }

    &.disabled {
      :before {
        background-color: rgb(246, 246, 246);
        border: 1px solid rgb(177, 177, 177);
      }
    }

    :before {
      background-color: rgb(255, 255, 255);
      content: '';
      width: 24px;
      height: 24px;
      display: block;
      position: absolute;
      top: 0px;
      left: 0px;
      border: 1px solid rgb(177, 177, 177);
      z-index: 1;
    }

    :after {
      position: absolute;
      content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI0OHB4IiBoZWlnaHQ9IjQ4cHgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDggNDg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiM4QjhCOEI7fQ0KCS5zdDF7ZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7ZmlsbDojOEI4QjhCO30NCjwvc3R5bGU+DQo8Zz4NCgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTkuNSwzNC41Yy0wLjMsMC0wLjYtMC4xLTAuOC0wLjNsLTcuNS02LjdjLTAuNS0wLjUtMC42LTEuMy0wLjEtMS44YzAuNS0wLjUsMS4zLTAuNiwxLjgtMC4xbDYuNiw1LjkNCgkJbDE3LjQtMTcuM2MwLjUtMC41LDEuMy0wLjUsMS44LDBjMC41LDAuNSwwLjUsMS4zLDAsMS44TDIwLjQsMzQuMkMyMC4xLDM0LjQsMTkuOCwzNC41LDE5LjUsMzQuNXoiPjwvcGF0aD4NCjwvZz4NCjwvc3ZnPg0K);
      top: -12px;
      left: -11px;
      filter: invert(74%) sepia(85%) saturate(336%) hue-rotate(151deg)
        brightness(89%) contrast(85%);
      z-index: 1;
      transform: scale(0);
      transform-origin: center center;
      transition: all 0.1s ease-in-out 0s;
    }
  }

  input[type='checkbox'] {
    height: 24px;
    width: 24px;
    opacity: 0;
    cursor: pointer;
    margin: 0px;
    z-index: 15;
    position: absolute;
    left: 0;
    top: 0;
  }
`
